/**
 * @fileoverview POST handler for the "/email/ip_warming/:app_group_id/engagement_data/register" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import type { PostEmailIpWarmingEngagementDataResultErrors } from "../emailIpWarmingAppGroupIdEngagementDataBeginUpload/types";
import { emailIpWarmingAppGroupIdEngagementDataRegisterCacheKeys } from "./constants";
import type {
  PostEmailIpWarmingAppGroupIdEngagementDataRegisterProps,
  EmailIpWarmingAppGroupIdEngagementDataRegisterResult,
} from "./types";

export const postEmailIpWarmingAppGroupIdEngagementDataRegister = reactQueryMutationAdapter(
  emailIpWarmingAppGroupIdEngagementDataRegisterCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostEmailIpWarmingEngagementDataResultErrors>()(
    (
      props: PostEmailIpWarmingAppGroupIdEngagementDataRegisterProps
    ): Promise<EmailIpWarmingAppGroupIdEngagementDataRegisterResult> => {
      const { appGroupId, planId, ...requestBody } = props;

      return fetch(
        `/email/ip_warming/${appGroupId}/engagement_data/register/${planId}`,
        "POST",
        requestBody,
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
